import * as React from 'react';
import { Accordion, Card, Image } from 'react-bootstrap';
import { connect } from 'react-redux';

export interface FAQProperties {
    header: string,
    body: string,
    keyId: string,
    activeKey: string,
}

class FAQItem extends React.Component<FAQProperties, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            accordianOpen: false,
        };
        this.handleAccidentAccordianArrow = this.handleAccidentAccordianArrow.bind(this);
    }

    handleAccidentAccordianArrow() {
        this.setState({ accordianOpen: !this.state.accordianOpen })
    }

    public render() {
        let isOpen = this.state.accordianOpen;

        //If using the activeKey prop then ignore the state.accordianOpen.
        if (this.props.activeKey != undefined) {
            isOpen = (this.props.keyId === this.props.activeKey);
        }

        return (
            <Card>
                <Accordion.Toggle as={Card.Header} eventKey={this.props.keyId} onClick={() => this.handleAccidentAccordianArrow()}>
                    <div className="row align-items-center">
                        <div className="col-10">
                            {this.props.header}
                         </div>
                        <div className={"col-2 accordion-arrow-svg" + (isOpen != false ? ' isRotatednew' : '')}></div>
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={this.props.keyId}>
                    <Card.Body>
                        <div className="text">
                            <p dangerouslySetInnerHTML={{ __html: this.props.body }}/>
                        </div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        )
    }
}

export default connect()(FAQItem);